import React from 'react'
import Box from '@material-ui/core/Box'
import CheckIcon from 'components/material-symbol/icons/Check'
import {
  SEGMENTED_BUTTON_CHECK_GAP,
  SEGMENTED_BUTTON_CHECK_SIZE,
} from 'lib/segmented-button-styles'

export function SegmentedToggleButtonContent({
  isSelected,
  showCheck = true,
  children,
}) {
  if (!showCheck) {
    return (
      <Box component="span" style={{ whiteSpace: 'nowrap' }}>
        {children}
      </Box>
    )
  }

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      component="span"
      width="100%"
      style={{
        whiteSpace: 'nowrap',
        columnGap: isSelected ? SEGMENTED_BUTTON_CHECK_GAP : 0,
      }}
    >
      {isSelected ? (
        <CheckIcon
          style={{
            color: 'currentColor',
            fontSize: SEGMENTED_BUTTON_CHECK_SIZE,
            flexShrink: 0,
          }}
        />
      ) : null}
      <Box component="span" style={{ whiteSpace: 'nowrap' }}>
        {children}
      </Box>
    </Box>
  )
}
